import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import styled from 'styled-components';
import { SketchPicker } from 'react-color';
import theme from '../../styles/theme';
import { getCellColors } from '../../core/cells';

import FontSVG from '../../assets/svg/font';

const _Cover = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;

const _Popover = styled.div`
  position: absolute;
  top: -40px;
  left: 25px;
  z-index: 999999;
`;

const _Relative = styled.span`
  position: relative;
`;

const _ColorSwatch = styled.div`
  background: ${props => props.color};
  cursor: pointer;
  width: 30px;
  height: 15px;
  border-radius: 2px;
  display: inline-block;
`;

class ColorPicker extends React.Component {

  constructor(props) {
    super();
    this.state = {
      displayColorPicker: false,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClick() {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  }

  handleClose() {
    this.setState({ displayColorPicker: false });
  }

  renderPicker() {
    const { color, colors, onChange } = this.props;

    if(this.state.displayColorPicker) {
      return (
        <_Popover>
          <_Cover onClick={this.handleClose}/>
          <SketchPicker 
            disableAlpha={true}
            color={color} 
            presetColors={colors} 
            onChange={onChange} 
            width={150}
            triangle="hide" />
        </_Popover>
      );
    }
  }

  render() {
    const { color, children } = this.props;

    const Element = children;

    return (
      <_Relative>
        <span onClick={this.handleClick}>{children}</span>
        {this.renderPicker()}
      </_Relative>
    );
  }
}

ColorPicker.propTypes = {
  colors: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

ColorPicker.defaultProps = {
  colors: theme.pallet,
}

const mapStateToProps = createSelector(
  getCellColors,
  (colors) => ({
    colors
  })
)

export default connect(mapStateToProps)(ColorPicker)


// WEBPACK FOOTER //
// ./src/components/common/color-picker.js